import * as React from 'react';
import { SectionEntry, MenuComponentProps } from './JRCAppLeftColumn.types';
import { ItemsIcon } from './JRCAppLeftColumn.styles';
import { JRCIcon } from '../JRCIcon/JRCIcon';
import { JRCMenuItem } from 'components/JRCMenuItem/JRCMenuItem';
import { JRCTooltip } from '../JRCTooltip/JRCTooltip';

export const JRCDefaultMenu = <T extends SectionEntry>(props: MenuComponentProps<T>) => {
    return (
        <>
            {props.isMinimized ? (
                <ItemsIcon
                    key={props.entry.key}
                    isActive={props.activeItem == props.entry.key}
                    aria-label={props.entry.label}
                    onClick={() => props.onClick(props.entry.key)}>
                    <JRCTooltip description={props.entry.label} position="right">
                        <JRCIcon
                            name={props.entry.icon}
                            size={20}
                            color={props.activeItem == props.entry.key ? 'overseas' : 'grey4'}
                        />
                    </JRCTooltip>
                </ItemsIcon>
            ) : (
                <JRCMenuItem
                    attr={props.entry.attribute}
                    icon={props.entry.icon}
                    label={props.entry.label}
                    size={16}></JRCMenuItem>
            )}
        </>
    );
};
